import React, { useState, useEffect } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import Project from "./project";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import portfolioService from "../../../services/portfolioService";

const FeaturedProject = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [projects, setProjects] = useState([]);
  const [photos, setPhotos] = useState([]);
  const [social, setSocialLinks] = useState([]);

  useEffect(() => {
    let project = portfolioService.getProject();
    setProjects(project);
    let social = portfolioService.getSocialLinks();
    setSocialLinks(social);
  }, []);

  const openLightbox = (id) => {
    const project = projects.find((project) => project.id === id);
    setPhotos(project.images);
    setViewerIsOpen(true);
  };
  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const projectFilter = (type) => {
    return projects.filter((project) => project.type === type);
  };
  return (
    <div className="container-fluid" id="projects">
      <div className="container pt-4">
        <section>
          <h4 className="text-center text-uppercase mt-4">
            Featured
            <strong> Projects</strong>
          </h4>
          <div className="row py-2">
            <div className="col-md-12 mb-3">
              <div className="d-flex justify-content-start">
                <h4 className="text-center text-uppercase my-3 pt-4 pb-3 ">
                  Web
                  <strong> Development</strong>
                </h4>
              </div>
              <Project
                projects={projectFilter("web")}
                openLightbox={openLightbox}
              ></Project>
              <div className="d-flex justify-content-start">
                <h4 className="text-center text-uppercase my-3 pt-4 pb-3 ">
                  Graphic
                  <strong> Design</strong>
                </h4>
              </div>
              <Project
                projects={projectFilter("graphic")}
                openLightbox={openLightbox}
              ></Project>
              <div>
                <h4 className="text-center text-uppercase my-3 pt-4 pb-3 ">
                  <b>Gallery</b>
                </h4>
              </div>
              <div className="row">
                <div className="col-lg-3 col-6 rounded project_gallary">
                  <img
                    src="https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/Photoshop%20Edit/WhatsApp%20Image%202021-01-15%20at%205.50.51%20PM.jpeg"
                    alt=""
                    className="img-fluid hoverable"
                  />
                </div>
                <div className="col-lg-3 col-6 rounded project_gallary">
                  <img
                    src="https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/Photoshop%20Edit/WhatsApp%20Image%202021-01-15%20at%205.52.14%20PM(1).jpeg"
                    alt=""
                    className="img-fluid hoverable"
                  />
                </div>
                <div className="col-lg-3 col-6 rounded project_gallary">
                  <img
                    src="https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/Photoshop%20Edit/WhatsApp%20Image%202021-01-15%20at%205.52.14%20PM.jpeg"
                    alt=""
                    className="img-fluid hoverable"
                  />
                </div>
                <div className="col-lg-3 col-6 rounded project_gallary">
                  <img
                    src="https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/Photoshop%20Edit/WhatsApp%20Image%202021-01-15%20at%205.51.16%20PM.jpeg"
                    alt=""
                    className="img-fluid hoverable"
                  />
                </div>
              </div>

              <div className="d-flex justify-content-start">
                <h4 className="text-center text-uppercase my-3 pt-4 pb-3 ">
                  Project Report
                  <strong> Design</strong>
                </h4>
              </div>
              <div className="row">
                <div className="col-lg-6 pb-3">
                  <object
                    data="https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/personal%2FProject%20report%20INSPIRE.pdf?alt=media&token=e6916a99-f15c-490c-a116-b264726e5ef3"
                    type="application/pdf"
                    width="100%"
                    className="project_report_pdf"
                  />
                </div>
                <div className="col-lg-6 pb-3">
                  <object
                    data="https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/personal%2FProject%20report%20Punit.pdf?alt=media&token=6f99c848-e095-407a-93b5-8b9d7644b871"
                    type="application/pdf"
                    width="100%"
                    className="project_report_pdf"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-start" id="resume">
                <h4 className="text-center text-uppercase my-3 pt-5 pb-3 ">
                  My
                  <strong> Resume</strong>
                </h4>
              </div>
              <div className="row">
                <div className="col-lg-2"></div>
                <div className="col-lg-8 pb-5">
                  <object
                    data="https://firebasestorage.googleapis.com/v0/b/inspire-graphics.appspot.com/o/personal%2FResume.pdf?alt=media&token=679e1eb3-e962-4b3b-959c-2ec8a74aff4f"
                    type="application/pdf"
                    width="100%"
                    height="800px"
                    className="project_report_pdf"
                  />
                </div>
              </div>

              <div className="text-center" id="contact">
                <p className="font-weight-bolder pt-5">What’s Next?</p>
                <h3 className="mb-3 py-0 pb-3 font-weight-bold">
                  Get In Touch
                </h3>
                <p className="font-weight-bolder pb-2">
                  My inbox is always open. Whether you have a question or just
                  want to say hi, I'll try my best to get back to you!
                </p>
                <Button
                  variant="outlined"
                  color="primary"
                  href="mailto:ashwanee2001gupta@gmail.com"
                >
                  Say Hello
                </Button>
                <div className="py-4 social-links">
                  {social.map((social) => (
                    <Tooltip title={social.label} arrow placement="bottom">
                      <a
                        key={social.label}
                        style={{ width: 35, height: 35, margin: "0.25rem" }}
                        className={`btn-floating white z-depth-1 btn-small`}
                        aria-label={social.label}
                        rel="noopener noreferrer"
                        target="_blank"
                        href={social.link}
                      >
                        <i
                          style={{ fontSize: "1rem", lineHeight: "35px" }}
                          className={social.icon + " " + social.anchorClass}
                        ></i>
                      </a>
                    </Tooltip>
                  ))}
                </div>
              </div>
            </div>

            <ModalGateway>
              {viewerIsOpen ? (
                <Modal onClose={closeLightbox}>
                  <Carousel
                    currentIndex={currentImage}
                    views={photos.map((x) => ({
                      ...x,
                      srcset: x.srcSet,
                      caption: x.title,
                    }))}
                  />
                </Modal>
              ) : null}
            </ModalGateway>
          </div>
        </section>
      </div>
    </div>
  );
};

export default FeaturedProject;
